module.exports = __webpack_public_path__ + "static/media/InvitationMaker-3.523fbf0c.webp";